import React from 'react';
import { Route, Switch } from 'react-router-dom';

import routes from '../../config/routes';
import PrivateRoute from './private';

const CustomRoute = (route) => {
  if (route.private) {
    return <PrivateRoute path={route.path} exact={route.exact} component={(props) => <route.component {...props} />} />;
  }

  return <Route path={route.path} exact={route.exact} render={(props) => <route.component {...props} />} />;
};

const Router = () => (
  <Switch>
    {routes.map((route) => (
      <CustomRoute key={route.path} {...route} />
    ))}
  </Switch>
);

export default Router;
